import { NgModule } from '@angular/core';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';


let uri: string;
const withCredentials = true;
export function createApollo(httpLink: HttpLink) {
  if (window['ebbApi']) {
    uri = `${window['ebbApi']}/graphql`;
  } else {
    uri = `https://${environment.devBaseUrl}/api/graphql`;
  }

  return {
    link: httpLink.create({ uri, withCredentials }),
    cache: new InMemoryCache(),
  };
}

@NgModule({
  exports: [ ApolloModule, HttpClientModule ],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [ HttpLink ]
    }
  ]
})
export class GraphQLModule {}
